module.exports = ".howpaybill{line-height: 30px}\n.adsbg{background-color: #9c3f90; display: inline-block; width: 100%; height: 408px; margin-top: 100px; color: #fff}\n.imgrel{position: relative; top:-65px}\n.ads-h{font-size: 20px; margin-top: 120px; margin-bottom: 30px}"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/gen-ads/gen-ads.component.css
// module id = ./src/app/payment/gen-ads/gen-ads.component.css
// module chunks = main